<template>
  <div class="palceBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>场馆列表</span>
        <div class="headerinput">
          <el-input v-model="input" style="width:200px" placeholder="搜索场馆"></el-input>
          <el-button type="primary" style="margin-left:15px">搜索</el-button>
        </div>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="场馆名称"></el-table-column>
          <el-table-column prop="name" label="状态">
            <template slot-scope="scope">
              <el-tag
                :type="[scope.row.name=='待审核'?'warning':'success']"
                effect="dark"
              >{{ scope.row.name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="gotoreview">审批</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          date: "北京体育馆",
          name: "待审核",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "上海文化艺术馆",
          name: "已审核",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ]
    };
  },
  methods: {
    gotoreview() {
      this.$router.push("/review");
    }
  }
};
</script>

<style>
.palceBody {
  width: 100%;
  height: 100%;
  /* background-color: aqua; */
}
.clearfix {
  display: flex;
  justify-content: space-between;
  font-weight: 800;
}
.headerinput {
  width: 300px;
  display: flex;
  /* justify-content: space-between; */
}
</style>